module.exports = __webpack_public_path__ + "6d92b2e4db64cdf8dd3deefd957be2c1.svg";